import React from 'react';

import Link from '@atlaskit/link/link';

import { CONTENT_HISTORY } from '@confluence/named-routes/entry-points/routes.ts';

export const getPageHistoryLink = (attributes: any) => {
	const { spaceKey, contentId, contentSlug } = attributes;
	return (...chunks: any[]): React.JSX.Element => (
		<Link
			target="_blank"
			href={CONTENT_HISTORY.toUrl({
				spaceKey,
				contentId,
				contentSlug,
			})}
		>
			{chunks}
		</Link>
	);
};
